import styled, { css } from 'styled-components'
import { MEDIA } from 'utils/constants'
import { Card } from 'components/forms'
const { DESKTOP_UP } = MEDIA

export const PageContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: column;
`

export const Container = styled.div`
  ${({ gap }) => css`
    align-items: center;
    justify-content: space-between;
    display: flex;
    width: unset;
    gap: 16px;
  `}
`

export const WrapperTitle = styled.div`
  font-family: var(--primary-font);
  font-weight: 600;
  font-size: 20px;
  line-height: 24px;

  ${({ firstContainer }) => firstContainer && css`
    @media screen and (max-width: 1200px) {
      margin-top: 28px;
    }
  `}

  ${({ isServices }) => isServices && css`
    font-size: 16px;
    line-height: 19.2px;
  `}

  ${({ isPet }) => isPet && css`
    margin-bottom: 24px;
  `}
`

export const AlignWrappers = styled.div`
  flex: 1;
  max-width: 1040px;
  margin-bottom: 24px;
  @media screen and ${DESKTOP_UP} {
    padding: 0 16px;
  }
`
export const WrapperForm = styled(AlignWrappers)`
  display: flex;
  flex-direction: column;

  ${({ noMargin }) => noMargin && css`
    margin-bottom: 0;
  `}
`
export const WrapperElements = styled.div`
  display: flex;
  margin-top: 24px;
  max-width: 754px;
  width: 100%;
  gap: 24px;
  flex-wrap: wrap;
  position: relative;
`

export const WayCard = styled(Card)`
  margin-bottom: 0;
  height: auto;
  max-width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
`
export const Option = styled.div`
  right: 16px;
`
export const ServiceOption = styled(Option)`
  @media screen and ${DESKTOP_UP} {
    right: calc(50% - 20px);
    bottom: 24px;
  }
`
export const Photo = styled.div`
  ${({ size, src, setDefaultPhoto, mobileSize }) => css`
    width: ${size || '40px'};
    height: ${size || '40px'};
    border-radius: 100%;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: flex-end;
    background-image: url("${src}");
    background-size: ${setDefaultPhoto ? 'contain' : 'cover'};
    background-repeat: no-repeat;
    background-position: center center;
    ${({ borderRadiusNone }) => borderRadiusNone && css`
      border-radius: 0;
    `}
    @media screen and (max-width: 1200px) {
      width: ${mobileSize || '40px'};
      height: ${mobileSize || '40px'};
      min-width: ${mobileSize || '40px'};
    }
  `}
`
export const TextInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  span:first-of-type {
    font-size: 16px;
    font-weight: 600;
    line-height: 19.2px;
    font-family: var(--primary-font);
  }

  span:last-of-type {
    font-size: 13px;
    font-weight: 400;
    line-height: 17.7px;
    font-family: var(--primary-font);
  }
`
export const AlertTitle = styled.p`
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  margin-bottom: 4px;
`
export const AlertContent = styled.p`
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`
